module.exports = __webpack_public_path__ + "static/media/red_tow.bc6e2b67.png";